/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespEditorialModuleOld_homepage$ref = any;
export type HpRespEditorialModuleOld_homepage = {
    readonly editorialModule: ({
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly cta: string | null;
            readonly description: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
        } | null> | null;
    } & ({
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly cta: string | null;
            readonly description: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
        } | null> | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null;
    readonly " $refType": HpRespEditorialModuleOld_homepage$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "HpRespEditorialModuleOld_homepage",
    "type": "Homepage",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": "editorialModule",
            "name": "module",
            "storageKey": "module(type:\"editorial\")",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "editorial"
                }
            ],
            "concreteType": null,
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "type": "EditorialModule",
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "EditorialItem",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cmsId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cta",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "link",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "imageUrl",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '3b7e90cbca8a25b0c1b2964b49a02727';
export default node;
